var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgGalleryLarge = function SvgGalleryLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.899,
    height: 24.899
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "GalleryLarge_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439aff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5535"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-image",
    d: "M25.28 26.457V7.155A2.508 2.508 0 0022.971 4.5H6.809A2.508 2.508 0 004.5 7.155v18.589A2.508 2.508 0 006.809 28.4c17.432 0 18.471-.482 18.471-1.943z",
    transform: "translate(-.881 -4)",
    fill: "url(#GalleryLarge_svg__a)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 174"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-image",
    d: "M24.4 21.744V3.155A2.663 2.663 0 0021.744.5H3.155A2.663 2.663 0 00.5 3.155v18.589A2.663 2.663 0 003.155 24.4h18.589a2.663 2.663 0 002.656-2.656zm-8.63-9.294z",
    fill: "none",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 3",
    d: "M12.288 20.775H6.062a.5.5 0 01-.426-.757l3.8-6.326a.5.5 0 01.858 0l2.661 4.443 3.489-5.977a.5.5 0 01.864 0l4.588 7.866a.5.5 0 01-.431.752z",
    fill: "#fff"
  })))));
};
export default SvgGalleryLarge;